export const CONTACT_ENTITY_LABEL = { singular: 'Kontakt', plural: 'Kontakte', gender: 'm' };

export const CONTACT_SELECTION_HINT = 'Kontakte sind ausgewählt – deren Aktionen finden Sie in der Auswahlleiste unten';
